import { DEBUG, DEFAULT_PREFS } from "./config";
import { getAppCardNode } from "./appCardDefault";
import { DomHelper } from "./domHelper";
import { Util } from "./util";
import { getBackendData, sendBackendData } from "./xhrbackend";
import { render } from "./desk";
const LDAP_BASE_DN_GROUP_APP = "ou=ui,ou=groups,dc=open-diakonie,dc=de";
export function appDeskAppAdmin(username, bearerToken, parentNode, app, userResponse) {
    if (DEBUG)
        console.log("-->appDeskAppAdmin");
    const additionalClassList = [];
    const idString = 'rudi-admin-app';
    if (!userResponse.odDeskPreferences)
        userResponse.odDeskPreferences = DEFAULT_PREFS;
    let content = "";
    const userPreferences = userResponse.odDeskPreferences;
    const cardNode = getAppCardNode(parentNode, app, username, userPreferences, bearerToken, false, additionalClassList, null, event => {
        const appGroupNode = document.getElementById('appGroups');
        if (appGroupNode)
            appGroupNode.classList.add('disabled');
        const fullScreenNode = document.getElementById('appFullscreen');
        if (fullScreenNode) {
            const appConfig = JSON.parse(app.odAppConfig);
            fullScreenNode.classList.remove('disabled');
            const headerNode = DomHelper.appendNode(fullScreenNode, 'header', []);
            DomHelper.appendNode(headerNode, 'h1', [], [], appConfig.title ? appConfig.title : "App Administration");
            const btnNode = DomHelper.appendNode(headerNode, 'div', ['od-button-area']);
            DomHelper.createButtonClose(btnNode, username, bearerToken, userPreferences);
            createButtonRefresh(btnNode, username, bearerToken, userPreferences);
            const adminPane = DomHelper.appendNode(fullScreenNode, 'section', ['odAdminPane']);
            const navNode = DomHelper.appendNode(adminPane, 'section', [], [], "", "odAdminNav");
            const listNode = DomHelper.appendNode(adminPane, 'section', [], [], "", "odAdminList");
            getBackendData("", "/admin/desk/app", "GET", "application/json", bearerToken, function (response) {
                const responseData = JSON.parse(response.target.response);
                appPartListRender(listNode, username, bearerToken, userPreferences, responseData);
            });
        }
    });
    let injectNodes = cardNode.getElementsByClassName('rudi-app-inject');
    const injectNode = injectNodes.item(0);
    if (injectNode) {
        injectNode.classList.remove('rudi-app-inject');
        injectNode.classList.remove('disabled');
        injectNode.classList.add('rudi-app-interaction');
        injectNode.setAttribute("id", idString);
        injectNode.innerHTML = content;
        createButtonOpenAppList(injectNode, username, bearerToken, userResponse.odDeskPreferences, app, idString);
    }
    else {
        console.log("Couldn't get Element to add content");
    }
}
export function appDeskMessageStatistic(username, bearerToken, parentNode, app, userResponse) {
    if (DEBUG)
        console.log("-->appDeskMessageStatistic");
    const additionalClassList = [];
    const idString = 'rudi-admin-app';
    if (!userResponse.odDeskPreferences)
        userResponse.odDeskPreferences = DEFAULT_PREFS;
    let content = "";
    const cardNode = getAppCardNode(parentNode, app, username, userResponse.odDeskPreferences, bearerToken, false, additionalClassList, null, (event) => {
        if (cardNode) {
            if (cardNode.classList.contains("app-open")) {
                cardNode.classList.remove('rudi-col-span-2');
                cardNode.classList.remove('app-open');
                cardNode.classList.add('rudi-max-height');
                DomHelper.removeCloseSection(cardNode);
            }
            else {
                cardNode.classList.add('app-open');
                cardNode.classList.add('rudi-col-span-2');
                cardNode.classList.remove('rudi-max-height');
                DomHelper.appendCloseSection(cardNode, (event) => {
                    cardNode.classList.remove('app-open');
                    cardNode.classList.remove('rudi-col-span-2');
                    cardNode.classList.add('rudi-max-height');
                });
            }
        }
    });
    let injectNodes = cardNode.getElementsByClassName('rudi-app-inject');
    const injectNode = injectNodes.item(0);
    if (injectNode) {
        injectNode.classList.remove('rudi-app-inject');
        injectNode.classList.remove('disabled');
        injectNode.classList.add('rudi-app-interaction');
        injectNode.setAttribute("id", idString);
        injectNode.innerHTML = content;
        DomHelper.appendSpinner(injectNode);
        getBackendData("", `/users/${username}/message/statistic`, "GET", "application/json", bearerToken, function (response) {
            const responseData = JSON.parse(response.target.response);
            injectNode.innerHTML = content;
            const listNode = DomHelper.appendNode(injectNode, 'section', [], [], '', 'od-msg-stat-list');
            let lastname = "";
            for (const item of responseData) {
                const listItem = DomHelper.appendNode(listNode, 'div', ['od-item']);
                DomHelper.appendNode(listItem, 'div', ['od-title'], [], lastname != item.appname ? item.appname : "");
                DomHelper.appendNode(listItem, 'div', ['od-version'], [], item.version);
                DomHelper.appendNode(listItem, 'div', ['od-amount'], [], item.amount.toString());
                lastname = item.appname;
            }
        });
    }
    else {
        console.log("Couldn't get Element to add content");
    }
}
function performInpersonate(usernameIMP, bearerToken, userResponse, username) {
    getBackendData('', `/users/${usernameIMP}`, "GET", "application/json", bearerToken, (result) => {
        userResponse = JSON.parse(result.target.response);
        if (!userResponse.name) {
            alert(`Es wurden keine Daten für ${usernameIMP} gefunden.`);
            return;
        }
        alert(`Sie sehen gleich den Desk in der Ansicht von ${userResponse.name} ${userResponse.surname}.\nUm den Modus wieder zu verlassen laden Sie die Seite neu.`);
        const mainNode = document.getElementById('appGroups');
        if (mainNode)
            mainNode.innerHTML = "";
        let bodyNode = document.getElementById('rudi-body');
        if (bodyNode) {
            bodyNode.classList.add('inpersonate');
            bodyNode.setAttribute('inp_by', username);
        }
        render(result, usernameIMP);
    });
    return userResponse;
}
export function appInpsersonate(username, bearerToken, parentNode, app, userResponse) {
    if (DEBUG)
        console.log("-->appInpsersonate");
    const additionalClassList = [];
    const idString = 'rudi-admin-inpersonate';
    if (!userResponse.odDeskPreferences)
        userResponse.odDeskPreferences = DEFAULT_PREFS;
    const cardNode = getAppCardNode(parentNode, app, username, userResponse.odDeskPreferences, bearerToken, false, additionalClassList);
    const injectNode = cardNode.querySelector('.rudi-app-inject');
    if (injectNode) {
        injectNode.classList.remove('rudi-app-inject');
        injectNode.classList.remove('disabled');
        injectNode.classList.add('rudi-app-interaction');
        injectNode.setAttribute("id", idString);
        const inputNode = DomHelper.appendInputText(injectNode, 'rudi-inpersonate-form', ['rudi-inline-icon'], [], 'username', '', '', []);
        const btnNode = DomHelper.appendNodeAsSibling(inputNode, 'button', ['btn', 'btn-primary'], []);
        DomHelper.appendNode(btnNode, 'i', ['fa-light', 'fa-paper-plane'], []);
        btnNode.addEventListener('click', (event) => {
            if (DEBUG)
                console.log('inpersonate clicked');
            let usernameIMP = inputNode.value;
            if (usernameIMP) {
                userResponse = performInpersonate(usernameIMP, bearerToken, userResponse, username);
            }
        });
        inputNode.addEventListener('keypress', (event) => {
            if (event.key == 'Enter') {
                let usernameIMP = inputNode.value;
                performInpersonate(usernameIMP, bearerToken, userResponse, username);
            }
        });
    }
}
function performLDAPSearch(usernameIMP, username, bearerToken, cardNode, injectNode, idString) {
    if (usernameIMP) {
        getBackendData('', `/users/${username}/queryuser?search=${usernameIMP}&inactive=true&searchdn=ou=people,dc=open-diakonie,dc=de&fields=*|createTimestamp|modifyTimestamp|memberOf|pwdChangedTime|pwdAccountLockedTime`, 'GET', 'application/json', bearerToken, (response) => {
            console.log("got response", response.target.response);
            const users = JSON.parse(response.target.response);
            console.log("users", users);
            if (!cardNode.classList.contains('rudi-col-span-4')) {
                cardNode.classList.add('rudi-col-span-4');
                cardNode.classList.remove('rudi-max-height');
            }
            let tableNodes = injectNode.querySelectorAll('table');
            tableNodes.forEach(element => {
                element.classList.add('disabled');
            });
            if (users && users.length === 1) {
                renderSingleLDAPUser(injectNode, users[0], false);
            }
            else {
                renderLDAPTable(injectNode, users);
            }
            DomHelper.scrollIntoView(cardNode).finally();
            DomHelper.appendCloseSection(cardNode, (event) => {
                closeLDAPApp(idString, cardNode);
            });
        });
    }
}
export function appLDAPQuery(username, bearerToken, parentNode, app, userResponse) {
    if (DEBUG)
        console.log("-->appLDAPQuery");
    const additionalClassList = [];
    const idString = 'rudi-admin-ldapquery';
    if (!userResponse.odDeskPreferences)
        userResponse.odDeskPreferences = DEFAULT_PREFS;
    function appLdapClickHandler(event) {
        console.log("my click handler", event);
    }
    const cardNode = getAppCardNode(parentNode, app, username, userResponse.odDeskPreferences, bearerToken, false, additionalClassList, null, true);
    const injectNode = cardNode.querySelector('.rudi-app-inject');
    if (injectNode) {
        injectNode.classList.remove('rudi-app-inject');
        injectNode.classList.remove('disabled');
        injectNode.classList.add('rudi-app-interaction');
        injectNode.setAttribute("id", idString);
        const inputNode = DomHelper.appendInputText(injectNode, 'rudi-ldapquery-form', ['rudi-inline-icon'], [], 'username', '', '', []);
        const btnNode = DomHelper.appendNodeAsSibling(inputNode, 'button', ['btn', 'btn-primary'], []);
        DomHelper.appendNode(btnNode, 'i', ['fa-light', 'fa-paper-plane'], []);
        btnNode.addEventListener('click', (event) => {
            if (DEBUG)
                console.log('query clicked');
            let usernameIMP = inputNode.value;
            performLDAPSearch(usernameIMP, username, bearerToken, cardNode, injectNode, idString);
        });
        inputNode.addEventListener('keypress', (event) => {
            if (event.key == 'Enter') {
                let usernameIMP = inputNode.value;
                performLDAPSearch(usernameIMP, username, bearerToken, cardNode, injectNode, idString);
            }
        });
    }
}
function closeLDAPApp(idString, cardNode) {
    let tableListNode = cardNode.querySelectorAll('table');
    tableListNode.forEach(node => {
        node.remove();
    });
    let closeNode = cardNode.querySelector('rudi-app-close');
    if (closeNode)
        closeNode.remove();
    cardNode.classList.add('rudi-max-height');
    cardNode.classList.remove('rudi-col-span-4');
    DomHelper.scrollIntoView(cardNode).finally();
}
function renderSingleLDAPUser(injectNode, user, fromTable) {
    if (fromTable) {
        let tableNode = injectNode.querySelector('table');
        if (tableNode)
            tableNode.classList.add('disabled');
        const buttonNode = DomHelper.appendNode(injectNode, 'button', ['btn', 'btn-primary', 'mt-2']);
        DomHelper.appendNode(buttonNode, 'i', ['fa-light', 'fa-list']);
        DomHelper.appendNode(buttonNode, 'span', [], [], "Zurück zur Liste");
        buttonNode.addEventListener('click', event => {
            tableNode.classList.remove('disabled');
            let detailNode = injectNode.querySelector('table.user-detail');
            if (detailNode)
                detailNode.remove();
            buttonNode.remove();
        });
    }
    else {
        let detailNode = injectNode.querySelector('table.user-detail');
        if (detailNode)
            detailNode.remove();
    }
    const additionalClassList = [];
    if (user.pwdAccountLockedTime == '000001010000Z')
        additionalClassList.push('user-locked');
    const displayNode = DomHelper.appendNode(injectNode, 'table', [...additionalClassList, 'user-detail'], [], '', `detail-${user.cn}`);
    const sortedEntries = Object.entries(user).sort(([labelA], [labelB]) => labelA.localeCompare(labelB));
    sortedEntries.forEach(([label, value]) => {
        const rowNode = DomHelper.appendNode(displayNode, 'tr', []);
        DomHelper.appendNode(rowNode, 'th', [], [], label);
        const valueNode = DomHelper.appendNode(rowNode, 'td', [], []);
        renderLDAPValue(valueNode, label, value);
    });
}
function renderLDAPValue(valueNode, label, value) {
    console.log(label, typeof value);
    const regexTimestamp = /^\d+Z/;
    const regexUnixTimestamp = /^\d{10}/;
    if (label == "userPassword") {
    }
    else if (label == "memberOf") {
        const listNode = DomHelper.appendNode(valueNode, 'ul', ['od-three-columns']);
        for (let group of value.sort((a, b) => {
            if (a.toLowerCase() > b.toLowerCase())
                return 1;
            if (a.toLowerCase() < b.toLowerCase())
                return -1;
            if (a.toLowerCase() == b.toLowerCase())
                return 0;
        })) {
            DomHelper.appendNode(listNode, 'li', [], [{ attr: 'title', value: group }], Util.getCNfromParentDN(group));
        }
    }
    else if (typeof value == 'string' && value.match(regexTimestamp)) {
        if (value === '000001010000Z') {
            valueNode.innerHTML = 'gesperrt';
        }
        else {
            valueNode.innerHTML = Util.ldapTimestring2Timestamp(value);
        }
    }
    else if (typeof value == 'string' && value.match(regexUnixTimestamp)) {
        valueNode.innerHTML = Util.unixTimestamp2DateString(Number(value) * 1000);
    }
    else if (label == 'odDeskPreferences') {
        const prettyJson = JSON.stringify(JSON.parse(value), null, 4);
        DomHelper.appendNode(valueNode, 'pre', [], [], prettyJson);
    }
    else {
        valueNode.innerHTML = value.toString();
    }
}
function renderLDAPTable(injectNode, users) {
    let detailNode = injectNode.querySelector('table.user-detail');
    if (detailNode)
        detailNode.remove();
    let tableNode = injectNode.querySelector('table');
    if (!tableNode) {
        tableNode = DomHelper.appendNode(injectNode, 'table', ['rd-user-list'], []);
    }
    else {
        tableNode.classList.remove('disabled');
        tableNode.innerHTML = "";
    }
    renderLDAPHeaderRow(tableNode);
    for (const user of users) {
        renderLDAPUserRow(injectNode, tableNode, user);
    }
}
function renderLDAPHeaderRow(table) {
    const rowNode = DomHelper.appendNode(table, 'tr', [], []);
    DomHelper.appendNode(rowNode, 'th', ['edit-icon'], []);
    DomHelper.appendNode(rowNode, 'th', [], [], 'Username');
    DomHelper.appendNode(rowNode, 'th', [], [], 'Vorname');
    DomHelper.appendNode(rowNode, 'th', [], [], 'Nachname');
    DomHelper.appendNode(rowNode, 'th', [], [], 'Mail');
}
function renderLDAPUserRow(injectNode, table, user) {
    const rowNode = DomHelper.appendNode(table, 'tr', [], []);
    const iconNode = DomHelper.appendNode(rowNode, 'td', ['edit-icon'], []);
    const iconString = user.pwdAccountLockedTime ? 'fa-user-slash' : 'fa-user';
    DomHelper.appendNode(iconNode, 'i', ['fa-light', iconString], []);
    rowNode.addEventListener('click', event => {
        console.log("Table row clicked", event);
        renderSingleLDAPUser(injectNode, user, true);
    });
    DomHelper.appendNode(rowNode, 'td', [], [], user.cn);
    DomHelper.appendNode(rowNode, 'td', [], [], user.givenName);
    DomHelper.appendNode(rowNode, 'td', [], [], user.sn);
    DomHelper.appendNode(rowNode, 'td', [], [], user.mail);
}
function createButtonOpenAppList(injectNode, username, bearerToken, userPreferences, app, idString) {
    const buttonNode = DomHelper.getFirstParentWithClass(injectNode, 'rudi-app');
    buttonNode.addEventListener('click', function (event) {
    });
}
function createButtonRefresh(injectNode, username, bearerToken, userPreferences) {
    const buttonNode = DomHelper.appendNode(injectNode, 'button', ['btn', 'btn-primary', 'mt-2', 'ms-1',], [{
            attr: 'id',
            value: ''
        }]);
    DomHelper.appendNode(buttonNode, 'i', ['fa-light', 'fa-refresh', 'me-1'], []);
    DomHelper.appendNode(buttonNode, 'span', [], [], 'aktualisieren');
    buttonNode.addEventListener('click', function (event) {
        const listNode = document.getElementById("odAdminList");
        if (listNode) {
            listNode.innerHTML = "";
            getBackendData("", "/admin/desk/app", "GET", "application/json", bearerToken, function (response) {
                const responseData = JSON.parse(response.target.response);
                appPartListRender(listNode, username, bearerToken, userPreferences, responseData);
            });
        }
    });
}
function enableInvalidMessage(parentElement, name, message) {
    const invalidNode = parentElement.querySelector(`#${name}-invalid`);
    if (invalidNode) {
        invalidNode.classList.remove('disabled');
        invalidNode.innerText = message;
    }
    const inputNode = parentElement.querySelector(`#app_create-${name.toLowerCase()}`);
    if (inputNode) {
        inputNode.classList.add('invalid');
    }
}
function disableInvalidMessage(parentElement, name) {
    const invalidNode = parentElement.querySelector(`#${name}-invalid`);
    if (invalidNode) {
        invalidNode.classList.add('disabled');
        invalidNode.innerText = "";
    }
    const inputNode = parentElement.querySelector(`app_create-${name.toLowerCase()}`);
    if (inputNode) {
        inputNode.classList.remove('invalid');
    }
}
function validateFormData(app, parentElement, withCN = false) {
    let formValid = true;
    if (app.odAppConfig) {
        try {
            JSON.parse(app.odAppConfig);
            disableInvalidMessage(parentElement, 'odAppConfig');
        }
        catch (e) {
            formValid = false;
            console.log("JSON-Parse-Error", e);
            enableInvalidMessage(parentElement, 'odAppConfig', "Die Config muss ein valides JSON-Object sein");
        }
    }
    let valueDescription = app.description;
    if (typeof valueDescription === 'string' && valueDescription.length > 3) {
        disableInvalidMessage(parentElement, 'description');
    }
    else {
        formValid = false;
        enableInvalidMessage(parentElement, 'description', "Der BOM Name darf nicht leer sein");
    }
    if (app.odAppIconType === 'font') {
        const regex = /^[-a-z_]+\s?[-a-z_]*$/;
        if (regex.test(app.odAppIcon)) {
            disableInvalidMessage(parentElement, 'odAppIcon');
        }
        else {
            formValid = false;
            enableInvalidMessage(parentElement, 'odAppIcon', "Die Liste der Icon Namen darf nur a-z_ enthalten und muss mit Leerzeichen getrennt sein.");
        }
    }
    if (withCN && app.cn) {
        const regex = /^odapp_[a-z0-9_]+$/;
        if (regex.test(app.cn)) {
            disableInvalidMessage(parentElement, 'cn');
        }
        else {
            formValid = false;
            enableInvalidMessage(parentElement, 'cn', "Der technische Name muss mit odapp_ beginnen und komplett in Kleinbuchstaben sein. Darf nur a-z0-9_ enthalten.");
        }
    }
    return formValid;
}
function handleAppCreate(username, bearerToken, event, parentDN, appListAll, groupNode) {
    const modalNode = document.getElementById('rudi-modal');
    const modalContentNode = document.getElementById('rudi-modal-content');
    const appItem = {
        cn: "odapp_",
        dn: "",
        odAppConfig: '{"requirenetwork":["zem-p1"]}',
        odAppIcon: "fa-light fa-triangle-exclamation",
        odAppIconType: "font",
        odAppTitle: "Neue App",
        odAppType: "link",
        odAppParent: parentDN,
        consentRequired: false
    };
    if (modalNode && modalContentNode) {
        DomHelper.showModal(modalNode);
        const titleNode = document.getElementById('rudi-modal-title');
        if (titleNode)
            titleNode.innerHTML = "Neue App / Gruppe anlegen";
        const formNode = document.getElementById('rudi-modal-form');
        if (formNode) {
            formNode.innerHTML = "";
            const section = createAppForm(bearerToken, formNode, appItem, modalNode, false, appListAll);
            const buttonSafeNode = DomHelper.appendNode(section, "button", ['btn', 'btn-secondary'], [], '');
            DomHelper.appendNode(buttonSafeNode, 'i', ['fa-light', 'fa-cloud-arrow-up']);
            DomHelper.appendNode(buttonSafeNode, 'span', [], [], 'Speichern');
            buttonSafeNode.addEventListener('click', function (event) {
                event.preventDefault();
                const formData = new FormData(formNode);
                let newApp = {
                    cn: formData.get('cn') ? formData.get('cn') : '',
                    odAppParent: parentDN,
                    odAppType: formData.get('odAppType') ? formData.get('odAppType') : '',
                    odAppTitle: formData.get('odAppTitle') ? formData.get('odAppTitle') : '',
                    odAppSubTitle: formData.get('odAppSubTitle') ? formData.get('odAppSubTitle') : '',
                    description: formData.get('description') ? formData.get('description') : '',
                    odAppDescription: formData.get('odAppDescription') ? formData.get('odAppDescription') : '',
                    odAppIconType: formData.get('odAppIconType') ? formData.get('odAppIconType') : '',
                    odAppIcon: formData.get('odAppIcon') ? formData.get('odAppIcon') : '',
                    odAppSortOrder: formData.get('odAppSortOrder') ? Number(formData.get('odAppSortOrder')) : null,
                    odAppLocation: formData.get('odAppLocation') ? formData.get('odAppLocation') : '',
                    odAppHelpLocation: formData.get('odAppHelpLocation') ? formData.get('odAppHelpLocation') : '',
                    odAppConfig: formData.get('odAppConfig') ? formData.get('odAppConfig') : '',
                    consentRequired: false
                };
                let formValid = validateFormData(newApp, formNode, true);
                if (!formValid) {
                    return;
                }
                sendBackendData('', `/admin/desk/app?username=${username}`, 'POST', 'application/json', bearerToken, newApp, function (response) {
                    modalNode.style.display = 'none';
                    newApp.dn = `${newApp},${LDAP_BASE_DN_GROUP_APP}`;
                    renderAppRow(groupNode, newApp, [], bearerToken, username, true);
                });
            });
            const buttonCancelNode = DomHelper.appendNode(section, "button", ['btn', 'btn-secondary'], [], '');
            DomHelper.appendNode(buttonCancelNode, 'i', ['fa-light', 'fa-ban']);
            DomHelper.appendNode(buttonCancelNode, 'span', [], [], 'Abbrechen');
            buttonCancelNode.addEventListener('click', function (event) {
                event.preventDefault();
                modalNode.style.display = 'none';
            });
        }
    }
}
function createAppForm(bearerToken, formNode, appItem, modalNode, shortnameReadonly = true, appListAll) {
    const typeMap = appListAll.map(item => item.odAppType);
    const typeSet = new Set(typeMap);
    const formName = 'app_create';
    const typeArray = Array.from(typeSet).sort((a, b) => {
        if (a < b)
            return -1;
        else if (a > b)
            return 1;
        return 0;
    });
    let typeSelectOptions = [];
    for (const item of typeArray) {
        typeSelectOptions.push({ label: item, value: item });
    }
    let cnAttr = [{
            attr: 'pattern',
            value: '[a-z0-9_]+'
        },
        {
            attr: 'title',
            value: 'Darf nur aus Buchstaben und Zahlen ohne Leerzeichen bestehen.'
        }];
    DomHelper.appendInputText(formNode, formName, [], [], 'cn', 'Technischer Name', appItem.cn, cnAttr);
    DomHelper.appendSelect(formNode, formName, [], 'odAppType', 'Typ', typeSelectOptions, appItem.odAppType);
    DomHelper.appendInputText(formNode, formName, [], [], 'odAppTitle', 'Titel', appItem.odAppTitle);
    DomHelper.appendInputText(formNode, formName, [], [], 'odAppSubTitle', 'Untertitel', appItem.odAppSubTitle);
    DomHelper.appendInputText(formNode, formName, [], [], 'description', 'BOM Name', appItem.description);
    DomHelper.appendInputText(formNode, formName, [], [], 'odAppDescription', 'Weitere Informationen', appItem.odAppDescription);
    DomHelper.appendSelect(formNode, formName, [], 'odAppIconType', 'Icon Type', [
        { label: 'Font', value: 'font' },
        { label: 'Datei', value: 'link' }
    ], 'font');
    DomHelper.appendInputText(formNode, formName, [], [], 'odAppIcon', 'Icon', appItem.odAppIcon);
    DomHelper.appendInputNumber(formNode, formName, [], [], 'odAppSortOrder', 'Sortierfolge', (appItem.odAppSortOrder ? appItem.odAppSortOrder : 100));
    DomHelper.appendInputText(formNode, formName, [], [], 'odAppLocation', 'Link', appItem.odAppLocation);
    DomHelper.appendInputText(formNode, formName, [], [], 'odAppHelpLocation', 'Link zur Hilfe', appItem.odAppHelpLocation);
    DomHelper.appendInputText(formNode, formName, [], [], 'odAppConfig', 'Config', appItem.odAppConfig);
    const section = DomHelper.appendNode(formNode, 'section', ['rudi-form-input-group'], []);
    const iconLabelNode = document.getElementById(`${formName}-${'odAppIcon'.toLowerCase()}-label`);
    if (iconLabelNode) {
        DomHelper.appendNode(iconLabelNode, 'a', ['small', 'ms-1'], [{ attr: "href", value: "https://fontawesome.com/search" }, { attr: "target", value: "_blank" }], 'Fontawesome');
    }
    return section;
}
function getSortetAppList(appList) {
    return appList.sort((a, b) => {
        if (typeof a.odAppSortOrder == 'undefined' || typeof b.odAppSortOrder == 'undefined')
            return 0;
        if (Number(a.odAppSortOrder) < Number(b.odAppSortOrder))
            return -1;
        if (Number(a.odAppSortOrder) > Number(b.odAppSortOrder))
            return 1;
        return 0;
    });
}
function renderTableHeader(parentElement) {
    const tableRowNode = DomHelper.appendNode(parentElement, 'tr', [], [], '');
    DomHelper.appendNode(tableRowNode, 'th', [], [], 'Aktionen');
    DomHelper.appendNode(tableRowNode, 'th', [], [], 'App');
    DomHelper.appendNode(tableRowNode, 'th', [], [], 'Icon');
    DomHelper.appendNode(tableRowNode, 'th', [], [], 'AppType');
    DomHelper.appendNode(tableRowNode, 'th', [], [], 'Link');
    DomHelper.appendNode(tableRowNode, 'th', [], [], 'Hilfe');
    DomHelper.appendNode(tableRowNode, 'th', [], [], 'Order');
    DomHelper.appendNode(tableRowNode, 'th', [], [], 'Row');
    DomHelper.appendNode(tableRowNode, 'th', [], [], 'Col');
    DomHelper.appendNode(tableRowNode, 'th', [], [], 'weitere Info');
    DomHelper.appendNode(tableRowNode, 'th', [], [], 'config');
}
function appPartListRender(parentElement, username, bearerToken, userPreferences, appList) {
    captureSearchBar(appList);
    const sortedAppList = getSortetAppList(appList);
    const tableNode = DomHelper.appendNode(parentElement, 'table', [], []);
    const tableHeadNode = DomHelper.appendNode(tableNode, 'thead', [], []);
    const tableBodyNode = DomHelper.appendNode(tableNode, 'tbody', [], []);
    renderTableHeader(tableHeadNode);
    let groups = appList.filter(element => element.odAppType === 'group');
    for (const group of groups) {
        renderGroup(tableBodyNode, group, sortedAppList, bearerToken, username);
    }
}
function renderGroup(parentElement, group, appListAll, bearerToken, username) {
    const appList = appListAll.filter(element => element.odAppParent === group.dn);
    const groupRowNode = renderAppRow(parentElement, group, ['rudi-admin-list-app-group'], bearerToken, username);
    const iconsNode = groupRowNode.querySelector('td.od-edit-icon-area');
    if (iconsNode) {
        const tdNodeEditIconDiv = DomHelper.appendNode(iconsNode, 'div', ['od-edit-column'], []);
        const buttonAddClassNode = DomHelper.appendNode(tdNodeEditIconDiv, 'i', ['fa-light', 'fa-plus']);
        DomHelper.addToolTip(buttonAddClassNode, 'Neue App in dieser Gruppe anlegen');
        buttonAddClassNode.addEventListener('click', function (event) {
            handleAppCreate(username, bearerToken, event, group.dn, appListAll, groupRowNode);
        });
    }
    for (const app of getSortetAppList(appList)) {
        if (app.odAppType === "[group]") {
            renderGroup(parentElement, app, appListAll, bearerToken, username);
        }
        else {
            renderAppRow(parentElement, app, [], bearerToken, username);
        }
    }
}
function enterEditMode(tableRowNode, app, bearerToken) {
    tableRowNode.classList.add('rudi-app-edit-mode');
    const appEditIconNode = tableRowNode.querySelector('.fa-edit');
    if (appEditIconNode) {
        appEditIconNode.classList.remove('fa-edit');
        appEditIconNode.classList.add('fa-save');
    }
    const appEditTTNode = tableRowNode.querySelector('.tt-btn-edit');
    if (appEditTTNode)
        appEditTTNode.innerText = "Speichern";
    const editableFields = tableRowNode.querySelectorAll('[odEditable="true"]');
    for (const field of editableFields) {
        field.classList.remove('disabled');
        field.setAttribute('contenteditable', 'true');
    }
}
function renderHistoryRow(parentElement, historyItem, prevItem) {
    const app = historyItem.beforeimage;
    const tableRowNode = DomHelper.appendNodeAsSibling(parentElement, 'tr', ['od-history-row'], [], '', historyItem.id);
    const tdNodeEditIconTD = DomHelper.appendNode(tableRowNode, 'td', ['od-edit-icon-area'], [], `${historyItem.nutzer}<br>${Util.isoString2DateString(historyItem.changed_at)}<br>${Util.isoString2TimeString(historyItem.changed_at)}`);
    const tdTitle = DomHelper.appendNode(tableRowNode, 'td', [], []);
    DomHelper.appendEditableDivNode(tdTitle, ['rudi-app-title', app.odAppTitle != prevItem.odAppTitle ? 'diff' : 'unchanged'], [], "odAppTitle", Util.formatTitle(app));
    DomHelper.appendNode(tdTitle, 'p', [app.odAppSubTitle != prevItem.odAppSubTitle ? 'diff' : 'unchanged'], [], app.odAppSubTitle ? app.odAppSubTitle : "");
    DomHelper.appendNode(tdTitle, 'p', ['od-bom-name', app.description != prevItem.description ? 'diff' : 'unchanged'], [], app.description ? app.description : "");
    DomHelper.appendNode(tdTitle, 'code', ['small'], [], app.cn);
    const tdNodeIconTd = DomHelper.appendNode(tableRowNode, 'td', [app.odAppIcon != prevItem.odAppIcon ? 'diff' : 'unchanged'], []);
    const tdNodeIconSection = DomHelper.appendNode(tdNodeIconTd, 'section', ['rudi-app-icon'], []);
    const tdNodeIconDiv = DomHelper.appendNode(tdNodeIconSection, 'div', ['rudi-app-icon'], []);
    const tdNodeIcon = DomHelper.appendNode(tdNodeIconDiv, 'i', app.odAppIcon.split(" "), []);
    DomHelper.addToolTip(tdNodeIcon, `${app.odAppIconType ? app.odAppIconType : ""}<br>${app.odAppIcon ? app.odAppIcon : ""}`);
    DomHelper.appendEditableDivNode(tdNodeIconTd, ['disabled'], [{ attr: 'odOnlyShowInEditMode', value: "true" }], "odAppIcon", (app.odAppIcon ? app.odAppIcon : "") + "");
    DomHelper.appendEditableDivNode(tdNodeIconTd, ['disabled'], [{ attr: 'odOnlyShowInEditMode', value: "true" }], "odAppSizeCol", (app.odAppIconType ? app.odAppIconType : "") + "");
    DomHelper.appendEditableTDNode(tableRowNode, [app.odAppType != prevItem.odAppType ? 'diff' : 'unchanged'], [], "odAppType", app.odAppType);
    DomHelper.appendEditableTDNode(tableRowNode, [app.odAppLocation != prevItem.odAppLocation ? 'diff' : 'unchanged'], [], "odAppLocation", app.odAppLocation);
    DomHelper.appendEditableTDNode(tableRowNode, [app.odAppHelpLocation != prevItem.odAppHelpLocation ? 'diff' : 'unchanged'], [], "odAppHelpLocation", app.odAppHelpLocation);
    DomHelper.appendEditableTDNode(tableRowNode, [app.odAppSortOrder != prevItem.odAppSortOrder ? 'diff' : 'unchanged'], [], "odAppSortOrder", (app.odAppSortOrder ? app.odAppSortOrder : "") + "");
    DomHelper.appendEditableTDNode(tableRowNode, [app.odAppSizeRow != prevItem.odAppSizeRow ? 'diff' : 'unchanged'], [], "odAppSizeRow", (app.odAppSizeRow ? app.odAppSizeRow : "") + "");
    DomHelper.appendEditableTDNode(tableRowNode, [app.odAppSizeCol != prevItem.odAppSizeCol ? 'diff' : 'unchanged'], [], "odAppSizeCol", (app.odAppSizeCol ? app.odAppSizeCol : "") + "");
    DomHelper.appendEditableTDNode(tableRowNode, [app.odAppDescription != prevItem.odAppDescription ? 'diff' : 'unchanged'], [], "odAppDescription", app.odAppDescription);
    DomHelper.appendEditableTDNode(tableRowNode, [app.odAppConfig != prevItem.odAppConfig ? 'diff' : 'unchanged'], [], "odAppConfig", app.odAppConfig);
    return tableRowNode;
}
function showHistory(tableRowNode, app, bearerToken, username) {
    if (DEBUG)
        console.log("showHistory", app);
    tableRowNode.classList.add('history-enabled');
    getBackendData('', `/admin/desk/app/${app.cn}/history?username=${username}`, 'GET', 'application/json', bearerToken, function (response) {
        if (DEBUG)
            console.log("History from Server");
        let i = -1;
        let currentRow = tableRowNode;
        const historyList = JSON.parse(response.target.response);
        for (const historyItem of historyList) {
            const prevApp = i >= 0 ? historyList[i].beforeimage : app;
            currentRow = renderHistoryRow(currentRow, historyItem, prevApp);
            i++;
        }
        const tableRowHide = DomHelper.appendNodeAsSibling(currentRow, 'tr', ['od-history-row-hide'], [], '');
        DomHelper.appendNode(tableRowHide, 'td', ['rudi-app-icon'], [{ attr: "colspan", value: "100%" }], '&nbsp');
    });
}
function hideHistory(tableRowNode, app, bearerToken) {
    tableRowNode.classList.remove('history-enabled');
    const nodeListe = document.querySelectorAll('.od-history-row');
    nodeListe.forEach(element => {
        element.remove();
    });
    const nodeListe2 = document.querySelectorAll('.od-history-row-hide');
    nodeListe2.forEach(element => {
        element.remove();
    });
}
function discardChanges(tableRowNode, app, bearerToken, username) {
    const appEditIconNode = tableRowNode.querySelector('.fa-save');
    const editableFields = tableRowNode.querySelectorAll('[odEditable="true"]');
    for (const field of editableFields) {
        field.setAttribute('contenteditable', 'false');
        if (field.getAttribute('odOnlyShowInEditMode') === 'true') {
            field.classList.add('disabled');
        }
    }
    tableRowNode.classList.remove('rudi-app-edit-mode');
    if (appEditIconNode) {
        appEditIconNode.classList.remove('fa-spin');
        appEditIconNode.classList.remove('fa-spinner-scale');
        appEditIconNode.classList.add('fa-edit');
        appEditIconNode.classList.remove('fa-save');
    }
    const appEditTTNode = tableRowNode.querySelector('.tt-btn-edit');
    if (appEditTTNode)
        appEditTTNode.innerText = "Bearbeiten";
}
function saveChanges(tableRowNode, app, bearerToken, username) {
    const appEditIconNode = tableRowNode.querySelector('.fa-save');
    const editableFields = tableRowNode.querySelectorAll('[odEditable="true"]');
    for (const field of editableFields) {
        const identifier = field.getAttribute("odName");
        if (identifier) {
            app[identifier] = field.innerText;
        }
    }
    if (!validateFormData(app, tableRowNode))
        throw "Validation failed";
    for (const field of editableFields) {
        field.setAttribute('contenteditable', 'false');
        if (field.getAttribute('odOnlyShowInEditMode') === 'true') {
            field.classList.add('disabled');
        }
    }
    if (appEditIconNode) {
        appEditIconNode.classList.add('fa-spin');
        appEditIconNode.classList.add('fa-spinner-scale');
        appEditIconNode.classList.remove('fa-save');
    }
    const appEditTTNode = tableRowNode.querySelector('.tt-btn-edit');
    if (appEditTTNode)
        appEditTTNode.innerText = "Bearbeiten";
    tableRowNode.classList.remove('rudi-app-edit-mode');
    const iconDivNode = tableRowNode.querySelector('section.rudi-app-icon');
    if (iconDivNode) {
        iconDivNode.innerHTML = '';
        DomHelper.addAppIcon(iconDivNode, app, `${app.odAppIconType ? app.odAppIconType : ""}<br>${app.odAppIcon ? app.odAppIcon : ""}`);
    }
    sendBackendData('', `/admin/desk/app/${app.cn}?username=${username}`, 'PUT', 'application/json', bearerToken, app, function (response) {
        if (appEditIconNode) {
            appEditIconNode.classList.remove('fa-spin');
            appEditIconNode.classList.remove('fa-spinner-scale');
            appEditIconNode.classList.add('fa-edit');
        }
    });
}
function renderAppRow(parentElement, app, cssClassList, bearerToken, username, asSibling = false) {
    let tableRowNode;
    if (asSibling) {
        tableRowNode = DomHelper.appendNodeAsSibling(parentElement, 'tr', [...cssClassList], [], '', app.cn);
    }
    else {
        tableRowNode = DomHelper.appendNode(parentElement, 'tr', [...cssClassList], [], '', app.cn);
    }
    const tdNodeEditIconTD = DomHelper.appendNode(tableRowNode, 'td', ['od-edit-icon-area'], []);
    const tdNodeEditIconDiv = DomHelper.appendNode(tdNodeEditIconTD, 'div', ['od-edit-column'], []);
    const tdNodeEditIcon = DomHelper.appendNode(tdNodeEditIconDiv, 'i', ['fa-light', 'fa-edit'], []);
    DomHelper.addToolTip(tdNodeEditIcon, 'Bearbeiten', 'tt-btn-edit');
    let isEditMode = false;
    tdNodeEditIcon.addEventListener('click', function (event) {
        if (isEditMode) {
            try {
                saveChanges(tableRowNode, app, bearerToken, username);
                tdNodeCancelIconDiv.classList.add('disabled');
                isEditMode = false;
            }
            catch (e) {
                if (DEBUG)
                    console.error("Validation failed");
            }
        }
        else {
            enterEditMode(tableRowNode, app, bearerToken);
            tdNodeCancelIconDiv.classList.remove('disabled');
            isEditMode = true;
        }
    });
    const tdNodeCancelIconDiv = DomHelper.appendNode(tdNodeEditIconTD, 'div', ['od-edit-column', 'disabled'], []);
    const tdNodeCancelIcon = DomHelper.appendNode(tdNodeCancelIconDiv, 'i', ['fa-light', 'fa-cancel'], []);
    DomHelper.addToolTip(tdNodeCancelIcon, 'Abbrechen');
    tdNodeCancelIcon.addEventListener('click', function (event) {
        if (isEditMode) {
            discardChanges(tableRowNode, app, bearerToken, username);
            tdNodeCancelIconDiv.classList.add('disabled');
            isEditMode = false;
        }
    });
    const tdNodeHistoryIconDiv = DomHelper.appendNode(tdNodeEditIconTD, 'div', ['od-edit-column'], []);
    const tdNodeHistoryIcon = DomHelper.appendNode(tdNodeHistoryIconDiv, 'i', ['fa-light', 'fa-rectangle-history'], []);
    DomHelper.addToolTip(tdNodeHistoryIcon, 'History einblenden');
    let isHistoryMode = false;
    tdNodeHistoryIcon.addEventListener('click', function (event) {
        if (!isHistoryMode) {
            showHistory(tableRowNode, app, bearerToken, username);
            isHistoryMode = true;
        }
        else {
            hideHistory(tableRowNode, app, bearerToken);
            isHistoryMode = false;
        }
    });
    const tdTitle = DomHelper.appendNode(tableRowNode, 'td', [], []);
    const aNode = DomHelper.appendNode(tdTitle, 'a', [], [], '', app.cn);
    DomHelper.appendEditableDivNode(aNode, ['rudi-app-title'], [], 'odAppTitle', Util.formatTitle(app));
    DomHelper.appendEditableDivNode(aNode, [], [], 'odAppSubTitle', app.odAppSubTitle ? app.odAppSubTitle : "");
    DomHelper.appendEditableDivNode(aNode, ['od-bom-name'], [], 'description', app.description ? app.description : "");
    DomHelper.appendNode(aNode, 'code', ['small'], [], app.cn);
    const tdNodeIconTd = DomHelper.appendNode(tableRowNode, 'td', [], []);
    const tdNodeIconSection = DomHelper.appendNode(tdNodeIconTd, 'section', ['rudi-app-icon'], []);
    DomHelper.addAppIcon(tdNodeIconSection, app, `${app.odAppIconType ? app.odAppIconType : ""}<br>${app.odAppIcon ? app.odAppIcon : ""}`);
    DomHelper.appendEditableDivNode(tdNodeIconTd, ['disabled'], [{ attr: 'odOnlyShowInEditMode', value: "true" }], "odAppIcon", (app.odAppIcon ? app.odAppIcon : "") + "");
    DomHelper.appendEditableDivNode(tdNodeIconTd, ['disabled'], [{ attr: 'odOnlyShowInEditMode', value: "true" }], "odAppIconType", (app.odAppIconType ? app.odAppIconType : "") + "");
    DomHelper.appendEditableTDNode(tableRowNode, [], [], "odAppType", app.odAppType);
    DomHelper.appendEditableTDNode(tableRowNode, [], [], "odAppLocation", app.odAppLocation);
    DomHelper.appendEditableTDNode(tableRowNode, [], [], "odAppHelpLocation", app.odAppHelpLocation);
    DomHelper.appendEditableTDNode(tableRowNode, [], [], "odAppSortOrder", (app.odAppSortOrder ? app.odAppSortOrder : "") + "");
    DomHelper.appendEditableTDNode(tableRowNode, [], [], "odAppSizeRow", (app.odAppSizeRow ? app.odAppSizeRow : "") + "");
    DomHelper.appendEditableTDNode(tableRowNode, [], [], "odAppSizeCol", (app.odAppSizeCol ? app.odAppSizeCol : "") + "");
    DomHelper.appendEditableTDNode(tableRowNode, [], [], "odAppDescription", app.odAppDescription);
    DomHelper.appendEditableTDNode(tableRowNode, [], [], "odAppConfig", app.odAppConfig);
    return tableRowNode;
}
function captureSearchBar(apps) {
    const searchBarWrapperNode = document.querySelector('section.top-search-bar-wrapper');
    if (searchBarWrapperNode) {
        const oldsearchBar = searchBarWrapperNode.querySelector('.top-search-bar');
        if (oldsearchBar.classList.contains('disabled'))
            return;
        if (oldsearchBar) {
            oldsearchBar.classList.add('disabled');
        }
        const inputNode = DomHelper.appendNode(searchBarWrapperNode, 'div', ['top-search-bar'], [{ attr: 'contenteditable', value: 'true' }, { attr: 'searchbase', value: 'apps' }]);
        inputNode.addEventListener('input', (event) => {
            const searchTerm = event.target.innerText.trim().toLowerCase();
            let filteredApps = [];
            let filter = apps.filter(app => {
                var _a, _b, _c, _d, _e;
                return app.cn.toLowerCase().includes(searchTerm) ||
                    app.odAppType.toLowerCase().includes(searchTerm) ||
                    app.odAppTitle.toLowerCase().includes(searchTerm) ||
                    ((_a = app.odAppSubTitle) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchTerm.toLowerCase())) ||
                    ((_b = app.odAppLocation) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(searchTerm)) ||
                    ((_c = app.odAppDescription) === null || _c === void 0 ? void 0 : _c.toLowerCase().includes(searchTerm.toLowerCase())) ||
                    ((_d = app.description) === null || _d === void 0 ? void 0 : _d.toLowerCase().includes(searchTerm.toLowerCase())) ||
                    ((_e = app.odAppConfig) === null || _e === void 0 ? void 0 : _e.toLowerCase().includes(searchTerm.toLowerCase()));
            });
            filteredApps.push(...filter);
            const activeNodes = document.querySelectorAll('tbody tr');
            for (const app of activeNodes) {
                if (filteredApps.some(appInfo => appInfo.cn === app.getAttribute('id'))) {
                    app.classList.remove('disabled');
                }
                else {
                    app.classList.add('disabled');
                }
            }
        });
    }
}
